/* eslint @typescript-eslint/ban-types: "off", @typescript-eslint/no-explicit-any: "off", prefer-spread: "off" */
export function execFunction(fn, args) {
    typeof fn === "function" && fn.apply(undefined, args);
}
//# sourceMappingURL=ExecFunction.js.map